import { Box, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel } from '@tom-ui/ui'
import { NonNumeric } from './RoutingInfo'
import Label from './label'

interface RoutingInfoProps {
  blockName?: string
  containerNumber?: string
  action: string
  isNonNumeric?: boolean
  nonNumeric?: NonNumeric
}

const LocationInfo = ({
  blockName,
  containerNumber,
  action,
  nonNumeric,
  isNonNumeric = false,
}: RoutingInfoProps) => {
  const { t } = useTranslate()

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      {isNonNumeric ? (
        <>
          <Box>
            <Typography variant='subtitle1'>{nonNumeric?.referenceNumber}</Typography>
            <Typography variant='body2'>
              {nonNumeric?.pickUpAmount}x {t('nonNumericContainers', 'non-numeric containers')}
            </Typography>
          </Box>
          <ColoredLabel color={'info'} label={action} />
        </>
      ) : (
        <>
          <Box>
            <Typography variant='h3' style={{ whiteSpace: 'pre-line' }}>
              {blockName}
            </Typography>
            <Typography variant='body1'>{containerNumber}</Typography>
          </Box>
          <Label color='info'>
            <Typography variant='caption'>{action}</Typography>
          </Label>
        </>
      )}
    </Box>
  )
}

export default LocationInfo
